import { webAdminModule } from "@admin/web-admin-module.di";
import { webAgentModule } from "@agent/web-agent-module.di";
import { webAuthenticationModule } from "@authentication/web-authentication-module.di";
import { webCampaignModule } from "@campaign/web-campaign-module.di";
import { webCoreModule } from "@core/web-core-module.di";
import { webCustomGraphModule } from "@custom-graph/web-custom-graph-module.di";
import { webFarmModule } from "@farm/web-farm-module.di";
import { authenticationModule } from "@iot-platform/authentication";
import { coreModule } from "@iot-platform/core";
import { userModule } from "@iot-platform/user";
import { webNotebookModule } from "@notebook/web-notebook-module.di";
import { webReportModule } from "@report/web-report-module.di";
import { webStationModule } from "@station/web-station-module.di";
import { webWeatherModule } from "@weather/web-weather-module.di";
import { Container } from "inversify";

// Register shared package modules explicitly
coreModule.registerModule();
authenticationModule.registerModule();
userModule.registerModule();

// Initialize the DI container with all modules
const container = new Container();

container.load(
    ...authenticationModule.subModulesDependencies,
    ...coreModule.subModulesDependencies,
    ...userModule.subModulesDependencies,

    // Web
    ...webAdminModule.subModulesDependencies,
    ...webAgentModule.subModulesDependencies,
    ...webAuthenticationModule.subModulesDependencies,
    ...webCampaignModule.subModulesDependencies,
    ...webCoreModule.subModulesDependencies,
    ...webCustomGraphModule.subModulesDependencies,
    ...webFarmModule.subModulesDependencies,
    ...webNotebookModule.subModulesDependencies,
    ...webReportModule.subModulesDependencies,
    ...webStationModule.subModulesDependencies,
    ...webWeatherModule.subModulesDependencies,
);

export { container };
